import {
  GET_GEOFENCE_LOCATIONS,
  GET_GEOFENCE_LOCATIONS_SUCCESS,
  GET_GEOFENCE_LOCATIONS_FAILURE,
  DELETE_GEOFENCE_LOCATION,
  DELETE_GEOFENCE_LOCATION_SUCCESS,
  DELETE_GEOFENCE_LOCATION_FAILURE,
  ADD_GEOFENCE_LOCATION,
  ADD_GEOFENCE_LOCATION_SUCCESS,
  ADD_GEOFENCE_LOCATION_FAILURE,
  CLEAR_CREATED_GEOFENCE_LOCATION,
  UPDATE_GEOFENCE_LOCATION,
  UPDATE_GEOFENCE_LOCATION_SUCCESS,
  UPDATE_GEOFENCE_LOCATION_FAILURE,
} from '../../modules/constants';

export const getGeofenceLocations = (payload) => ({
  type: GET_GEOFENCE_LOCATIONS,
  payload,
});

export const getGeofenceLocationsSuccess = (locations) => ({
  type: GET_GEOFENCE_LOCATIONS_SUCCESS,
  payload: locations,
});

export const getGeofenceLocationsFailure = (error) => ({
  type: GET_GEOFENCE_LOCATIONS_FAILURE,
  payload: error,
});

export const deleteGeofenceLocation = (locationId) => ({
  type: DELETE_GEOFENCE_LOCATION,
  payload: locationId,
});

export const deleteGeofenceLocationSuccess = (locationId) => ({
  type: DELETE_GEOFENCE_LOCATION_SUCCESS,
  payload: locationId,
});

export const deleteGeofenceLocationFailure = (error) => ({
  type: DELETE_GEOFENCE_LOCATION_FAILURE,
  payload: error,
});

export const addGeofenceLocation = (locationData) => ({
  type: ADD_GEOFENCE_LOCATION,
  payload: locationData,
});

export const addGeofenceLocationSuccess = (location) => ({
  type: ADD_GEOFENCE_LOCATION_SUCCESS,
  payload: location,
});

export const addGeofenceLocationFailure = (error) => ({
  type: ADD_GEOFENCE_LOCATION_FAILURE,
  payload: error,
});

export const updateGeofenceLocation = (locationData) => ({
  type: UPDATE_GEOFENCE_LOCATION,
  payload: locationData,
});

export const updateGeofenceLocationSuccess = (location) => ({
  type: UPDATE_GEOFENCE_LOCATION_SUCCESS,
  payload: location,
});

export const updateGeofenceLocationFailure = (error) => ({
  type: UPDATE_GEOFENCE_LOCATION_FAILURE,
  payload: error,
});



export const clearCreatedGeofenceLocation = () => ({
  type: CLEAR_CREATED_GEOFENCE_LOCATION,
});